













import { Result } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { EVENTS } from '../../../bus/events.const';
import { UpdateResultMutationPayload } from '../../../store/search/mutations/update-result.mutation';
import { VueCssClasses } from '../../../utils/types';
import EventButton from '../event-button.vue';
import HeartIcon from '../icons/heart-icon.vue';

@Component({
  components: {
    EventButton,
    HeartIcon
  }
})
export default class ResultWishlist extends Vue {
  @Prop({ required: true })
  item: Result;

  get label(): string {
    return this.item.isWishlisted
      ? this.$x.messages.results.removeFromWishlist
      : this.$x.messages.results.addToWishlist;
  }

  get buttonEvent(): string {
    return this.item.isWishlisted
      ? EVENTS.CallRemoveFromWishlistClientEvent
      : EVENTS.CallAddToWishlistClientEvent;
  }

  get eventButtonCssClasses(): VueCssClasses {
    return [
      'ebx-result-wishlist', {
        'ebx-result-wishlisted': this.item.isWishlisted
      }
    ];
  }

  get eventData(): UpdateResultMutationPayload {
    return {
      result: this.item,
      update: {
        isWishlisted: !this.item.isWishlisted
      }
    };
  }

  get iconCssClasses(): VueCssClasses {
    return {
      'ebx-icon--filled': this.item.isWishlisted
    };
  }
}
